export const toSlug = (v) =>
	String(v)
		.toLowerCase()
		.replace(/\s+/g, '-')
		.replace(/[^a-z0-9-]/g, '');

export default toSlug;
